import { Breadcrumbs, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';

export const StyledContainer = styled('div')(
  ({ isMobile }: { isMobile: boolean }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: isMobile ? 'center' : 'flex-start',
  }),
);

export const StyledBreadCrumbsContainer = styled(Breadcrumbs)(
  ({ theme, isMobile }: { theme: ICustomTheme; isMobile: boolean }) => ({
    marginBottom: isMobile ? theme.spacing(2) : theme.spacing(4),
  }),
);

export const StyledBreadCrumb = styled(Typography)(
  ({
    theme,
    isMobile,
    isCurrent,
  }: {
    theme: ICustomTheme;
    isMobile: boolean;
    isCurrent?: boolean;
  }) => ({
    fontSize: isMobile ? 16 : 18,
    fontWeight: isCurrent ? 'bold' : 'normal',
    color: isCurrent ? theme.colors.paletteFromBO.main : theme.colors.grey.main,
  }),
);

export const StyledSectionTitle = styled(Typography)(
  ({ theme, isMobile }: { theme: ICustomTheme; isMobile: boolean }) => ({
    fontSize: isMobile ? 24 : 32,
    fontWeight: 'bold',
    color: theme.colors.paletteFromBO.main,
    marginBottom: isMobile ? theme.spacing(2) : theme.spacing(4),
  }),
);
